$('.js-show-flat-data').hover(function() {

    $('.js-show-flat-data.hovered').removeClass('hovered');
    $('span', this).addClass('hovered');
    let flat_id = $(this).data('flat-id');
    $('.flat-data').hide();

    let info_box = $('.flat-data[data-flat-id="' + flat_id + '"]');

    let parentElement = $('.floor-plan-svg')[0];

    let svgBox = $(this)[0].getBoundingClientRect();
    let parentBox = parentElement.getBoundingClientRect();

    let relativeTop = svgBox.top - parentBox.top;
    let relativeLeft = svgBox.left - parentBox.left;

    let left = relativeLeft + $('g', this)[0].getBBox().width;

    if(left > 1250){
        left = relativeLeft - info_box.width() + 100;
        info_box.addClass('left-side');
    }

    info_box.css({
        top: relativeTop - 80,
        left: left - 250
    }).show();
});

$('.floor-plan-svg').mouseleave(function(){
    $('.flat-data').hide();
})
